<template>

  <div class="modal-mask" v-show="showFieldCloneModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <div class="container">
            <div class="row">
              <slot name="header">Свойства</slot>
            </div>
          </div>
        </div>
        <div class="modal-body">
            <div>
                <div class="col-12">
                  <span class="p-1 mr-2">
                    поиск класса
                  </span>
                  <input type="text" v-model="product_search" @keyup="searchProduct">
                </div>
                <div class="col-12 pt-3" v-if="product_prefetched.length > 0">
                  <span class="p-1 mr-2">
                    код класса
                  </span>
                  <select id="prefetched" v-model="product_id" @change="loadProductFields">
                    <option v-for="prod in product_prefetched" :key="prod.code" :value="prod.product_id">
                      {{prod.code}}
                    </option>
                  </select>
                </div>
                <div class="col-12 pt-3"  v-if="product_fields.length > 0">
                  выбрать поле класса
                  <div v-for="field in product_fields" :key="field.id">
                    <label :for="'field'+field.id">
                      {{field.title}}
                    </label>
                    <input type="checkbox" :value="field.id" :id="'field'+field.id" v-model="selectedFields">
                  </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button class="modal-button btn btn-danger" @click="updateTab('update',false)">Закрыть</button>
            <button class="modal-button btn btn-success" @click="fieldClone()">Добавить</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {POST, GET} from "@/shared/api";

export default {
  props: {
    selectedProduct: {
      code: null,
      title: null
    },
    showFieldCloneModal: false,
  },
  data() {
    return {
      product_search: "",
      product_id: null,
      product_prefetched: [],
      product_fields: [],
      selectedFields: [],
      searchField: false,
    }
  },
  methods: {
    updateTab(event = 'update', spec) {
      this.$emit(event, spec);
      // console.log(this.specification.fields);
    },
    fieldClone() {
      POST({
          "product_id": this.product_id,
          "field_ids": this.selectedFields,
          "to_product_id": this.selectedProduct
        },
        "/product/fields/clone", this).then(() => {
        this.updateTab('update',{state:"updated"})
      })
      .catch(() => {
        this.updateTab('update',{state:"err"})
      });
    },
    addRowRange() {
      this.fieldValues.push({value: {from: "", to: ""}});
    },
    deleteRow(index) {
      if (typeof this.fieldValues[index].state !== 'undefined') {
        if (this.fieldValues[index].state === "A") {
          this.fieldValues[index].state = "P";
        } else {
          this.fieldValues[index].state = "A";
        }
      } else {
        this.fieldValues.splice(index, 1);
      }
    },
    addRowCheckBox() {
      this.fieldValues.push({value: ""});
    },
    deleteRowCheckBox(index) {
      this.fieldValues.splice(index, 1);
    },
    searchProduct(){
      if(this.product_search){
        GET({search: this.product_search}, "/prefetch", this, false, false).then((result)=>{
          this.product_prefetched = result.data;
          this.selectedFields = [];
          this.product_fields = [];
        })
      }
    },
    loadProductFields(){
      if(this.product_id){
        GET([], "/getFieldsByProductId/"+this.product_id, this, false, false).then((result) => {
          this.product_fields = result.fields.filter((field)=> field.index != 0);
          this.selectedFields = [];

        })
      }
    },
    showFindFieldPart(){
      this.searchField = !this.searchField;
      if(!this.searchField){
        this.selectedFields = [];
      }
    }
  },
}
</script>

<style scoped>

</style>
